import { UICheckButton, UIControl, UITextArea, UITextField, UIView, UIViewController } from "uikit";
import { MUIComboBox } from "muikit";
import { StepView, StepViewProtocol } from "./StepView";
import { isValidEmail, isValidPhone, DLDB } from "dldb";

export interface BookingClientProtocolDelegate
{
  onClientFormDidChange ( vc: BookingClientViewController ) : void ;
}

export declare function intlTelInput(layer:any, config:any);

export class BookingClientViewController extends UIViewController implements StepViewProtocol
{
    delegate         : BookingClientProtocolDelegate = null ;
    name             : string         = "" ;
    email            : string         = "" ;
    phone            : string         = "" ;
    message          : string         = "" ;
    allergies        : boolean        = false ;
    allergens        : string         = "" ;
    
    stepView: StepView;

    private nameTextField     : UITextField   = null ;
    private emailTexteField   : UITextField   = null ;
    private phoneTextField    : UITextField   = null ;
    private allergiesCB       : UICheckButton = null ;
    private allergiesTextArea : UITextArea    = null ;
    private languageView      : UIView ;
    private languageComboBox  : MUIComboBox   = null;
    private messageTextArea   : UITextArea    = null ;
    private couponView        : UIView;

    private errorNameView    : UIView = null ;
    private errorEmailView   : UIView = null ;
    private errorPhoneView   : UIView = null ;


    viewDidLoad ( )
    {
        this.nameTextField.setOnChangeText( this, function(this:BookingClientViewController, control:UITextField, value:string) { this.onChangeText( "name", value ) } );
        this.emailTexteField.setOnChangeText( this, function(this:BookingClientViewController, control:UITextField, value:string) { this.onChangeText( "email", value ) } );
        this.phoneTextField.setOnChangeText( this, function(this:BookingClientViewController, control:UITextField, value:string) { this.onChangeText( "phone", value ) } );

        this.allergiesCB?.addTarget( this, this.onHasAllergiesCheck, UIControl.Event.touchUpInside );
        if (this.allergiesTextArea) this.allergiesTextArea.setOnChangeText( this, function(this:BookingClientViewController, control:UITextArea, value:string) { this.onChangeText( "allergens", value ) } );
        if (this.allergiesTextArea) this.allergiesTextArea.hidden = true;

        if (this.messageTextArea) this.messageTextArea.setOnChangeText( this, function(this:BookingClientViewController, control:UITextArea, value:string) { this.onChangeText( "comments", value ) } );

        this.languageView.hidden = true;
        this.couponView.hidden = true;

        this.setErrors( [] ) ;
        if(this.allergiesTextArea) this.allergiesTextArea.enabled = false ;
    }

    private phoneValidation:any = null;
    viewDidAppear(animated?: any): void {
      super.viewDidAppear(animated);
      // this.phoneValidation = intlTelInput(this.phoneTextField.inputLayer, {
      //   preferredCountries: ["es", "gb", "de", "fr", "us"],
      //   utilsScript: "libs/intl-tel-input/js/utils.js"
      // });
    }

    private onChangeText ( field: string, value: string )
    {
      this[ field ] = value ;      
      this.clearError( field ) ;
      this.notify( ) ;

      if ( field === "message" ) {
        DLDB.shared.cart().comments = value;
      }
      else { 
        DLDB.shared.cart()[ field ] = value; 
      }
    }

    private onHasAllergiesCheck ( )
    {
      const value = this.allergiesCB.on ;

      this.allergies = value ;
      if (this.allergiesTextArea) this.allergiesTextArea.hidden = !value ;
    }

    notify ( )
    {      
      this.delegate?.onClientFormDidChange( this ) ;
    }


    dryCheck ( )
    {
      const errors = []
          , checkIsValid = ( field: string, valid: boolean ) =>
            {
              if ( !valid )
                   errors.push( field ) ;

              return valid ;
            } ;

      checkIsValid( "name"   , this.name.length > 2       ) ;
      checkIsValid( "email"  , isValidEmail( this.email ) ) ;
      checkIsValid( "phone"  , isValidPhone( this.phone ) ) ;
      // if ( !this.phoneValidation.isValidNumber() ) { errors.push ( "phone" ); }

      return errors ;
    }
    
    check ( )
    {
      const errors = this.dryCheck( ) ;

      this.setErrors( errors ) ;

      return errors.length === 0 ;
    }

    
    setErrors ( errors: string[] )
    {
      const errorSpec = this.errorSpec( ) ;

      for ( const err in errorSpec )
            this.clearError( err ) ;

      for ( const err of errors )
            if ( err in errorSpec )
                 errorSpec[ err ].hidden = false ;
    }


    clearError ( error: string )
    {
      const errorSpec = this.errorSpec( ) ;

      if ( errorSpec.hasOwnProperty( error ) )
           errorSpec[ error ].hidden = true ;
    }


    private errorSpec ( )
    {
      return { "name"   : this.errorNameView
             , "email"  : this.errorEmailView
             , "phone"  : this.errorPhoneView
             }
    }

    public asJSON ( )
    {
      let phone = this.phone.indexOf("+") != -1 ? this.phone : "+34" + this.phone;

      return { "name": this.name
            //  , "phone": this.phoneValidation.getNumber()
             , "phone": phone
             , "phoneCountryISO2": "ES" //this.phoneValidation.getSelectedCountryData()["iso2"] 
             , "email": this.email
             , "comments": this.messageTextArea.text
             , "allergies": this.allergies? this.allergens : ""
             , "allergens": this.allergiesTextArea?.text
             } ;
    }

    public clear ( )
    {
      this.name    = "" ;
      this.email   = "" ;
      this.phone   = "" ;
      this.message = "" ;
      this.allergies = false ;
      this.allergens = "" ;

      this.nameTextField.text = ""  ;
      this.phoneTextField.text =  "" ;
      this.emailTexteField.text = "" ;
      this.messageTextArea.text = "" ;
      this.allergiesCB.on = false ;
      if (this.allergiesTextArea) this.allergiesTextArea.text = "" ;

      this.setErrors( [] ) ; 
    }
}